import React from 'react';
import { FormField } from '@cp/ds/src/components/form';
import { FormFieldName } from '../../model/form';
import { formatDateLabel } from '../../model/utils/formatDateLabel';
import { useDate } from '../../model/hooks/useDate';
import { DateFieldProps } from './model';

export const DateField: React.FC<DateFieldProps> = ({ form, submit, sx }) => {
  useDate({ form, submit });

  return (
    <FormField
      fieldContainerProps={{ sx }}
      fieldLabel="Выберите день"
      labelDateFormat={formatDateLabel}
      name={FormFieldName.Date}
      pickerType="date"
      placeholder="Не важно"
      size="small"
      type="dateTimePicker"
    />
  );
};
